import React, { useEffect, useState, useContext } from "react";
import CurrencyFormat from "react-currency-format";
import { Dropdown, Image, Card, Accordion, Offcanvas } from "react-bootstrap";
import "rc-slider/assets/index.css";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SocketContext from "../../context/SocketContext";
import { Scrollbars } from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";

// import components
import OpenPosition from "./OpenPosition";
import TradeviewChart from "./TradeviewChart";
import ClosedOrders from "./ClosedOrder";
import Orderplace from "./orderplace";
import PendingPosition from "./pendingPosition";

//import api
import {
  getPairList,
  setPairList,
  setMarketPrice,
  setTradePair,
  getAssetByCurrency,
  setUserFirstCurrency,
  setUserSecondCurrency,
  getMarketPrice,
  getAllOpenPosition,
  updateTradeAsset,
  getAllPendingPosition,
  closeAllOrder,
} from "../../api/tradeAction";

// lib
import isEmpty from "../../lib/isEmpty";
import { unrealizedPnL } from "../../lib/bybit";
import { toFixedDown, truncateDecimals } from "../../lib/roundOf";
import { userWalletList } from "../../api/walletAction";
import { toastAlert } from "../../lib/toastAlert";
import { IncCntObjId } from "../../lib/generalFun";
import { dateTimeFormat } from "../../lib/dateTimeHelper";

import Slider from "react-slick";
import OrderBook from "./OrderBook";
import TopStories from "./TopStories";
import EconomicCalender from "./EconomicCalender";
import TradingViewWidget from "../Hedging/header";
import CryptoTable from "./CryptoTable";
import FinanceHeatmap from "./heatMap";
import MarketOverview from "./marketOverView";
import EquityHeatMap from "./equityHeatMap";
import AreaChart from "./areaChart";
import TechnicalWidget from "./technicalWidget";

const assetType = ["Crypto", "Currencies", "Stocks", "Indices", "Commodities"];

const ProTrade = () => {
  const history = useNavigate();
  const { tikerRoot } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const socketContext = useContext(SocketContext);
  const { t, i18n } = useTranslation();

  //state
  const [activeTradeMethod, setActiveTradeMethod] = useState("buy");
  const [pairLists, setPairLists] = useState([]);
  const [totalpair, setTotalPair] = useState([]);
  const [pairdatas, setPairdatas] = useState([]);
  const [CloseAllLoder, setCloseAllLoder] = useState(false);
  const [totalPNL, setTotalPNL] = useState(0);
  const [available, setAvailable] = useState({});
  const [tradedata, setTradeData] = useState([]);
  const [currencyData, setCurrency] = useState([]);
  const [pendingdata, setPendingData] = useState([]);
  const [symbols, setSymbols] = useState([]);
  const [showMobileTrade, setShowMobileTrade] = useState(false);

  //redux
  const pairData = useSelector((state) => state.tradePair);
  const pairListData = useSelector((state) => state.pairList);
  const walletData = useSelector((state) => state.wallet);
  const currency = useSelector((state) => state.currency);
  const priceConversion = useSelector((state) => state.priceConversion);
  const marketPrice = useSelector((state) => state.marketPrice);

  //function
  const handleStakingMethodClick = (button) => {
    setActiveTradeMethod(button);
  };

  const fetchAssetByCurrency = async (spotPairId, type) => {
    try {
      const { status, result } = await getAssetByCurrency(spotPairId);
      if (status == "success") {
        if (type == "firstCurrency") {
          setUserFirstCurrency(result, dispatch);
        } else if (type == "secondCurrency") {
          setUserSecondCurrency(result, dispatch);
        }
      } else {
      }
    } catch (err) {
      console.log(err, "errro");
    }
  };

  const getallPendingData = async () => {
    const { status, result } = await getAllPendingPosition({});
    if (status == "success") {
      setPendingData(result);
      let totalPnl = 0;
      result?.result &&
        result?.result?.length > 0 &&
        result.result.map((item, key) => {
          let price = item.side == "sell" ? item.askPrice : item.bidPrice;
          let pnl = unrealizedPnL({
            entryPrice: item.entryPrice,
            quantity: item.quantity,
            lastPrice: price,
            buyorsell: item.side,
          });
          totalPnl += pnl;
        });
      setTotalPNL(truncateDecimals(totalPnl, 2));
    }
  };

  const fetchPairList = async () => {
    try {
      const { status, result } = await getPairList();
      if (status == "success") {
        setPairdatas(result);
        setPairList(result, dispatch);
        if (result && result.length > 0) {
          if (isEmpty(tikerRoot)) {
            let pair = `${result[0].firstCurrencySymbol}_${result[0].secondCurrencySymbol}`;
            history("/protrade/" + result[0].tikerRoot);
            await fetchAssetByCurrency(
              result[0].firstCurrencyId,
              "firstCurrency",
            );
            await fetchAssetByCurrency(
              result[0].secondCurrencyId,
              "secondCurrency",
            );
            await setMarketPrice(result[0], dispatch);
            await setTradePair(result[0], dispatch);
            // getMarketPrice(result[0]._id, dispatch);
          } else {
            let currency = tikerRoot.split("_");
            let pairDetail = result.find((el) => el.tikerRoot == tikerRoot);
            // console.log("pairDetail", pairDetail);
            if (isEmpty(pairDetail && pairDetail)) {
              history("/404");
            }
            await fetchAssetByCurrency(
              pairDetail.firstCurrencyId,
              "firstCurrency",
            );
            await fetchAssetByCurrency(
              pairDetail.secondCurrencyId,
              "secondCurrency",
            );
            // // getMarketPrice(pairDetail._id, dispatch);
            await setMarketPrice(pairDetail, dispatch);
            await setTradePair(pairDetail, dispatch);
          }
        }
      } else {
      }
    } catch (err) {
      console.log("errrrrrrrr", err);
    }
  };

  const handlePairChange = async (datas) => {
    let pair = `${datas.firstCurrencySymbol}_${datas.secondCurrencySymbol}`;
    history("/protrade/" + datas.tikerRoot);
    await fetchAssetByCurrency(datas.firstCurrencyId, "firstCurrency");
    await fetchAssetByCurrency(datas.secondCurrencyId, "secondCurrency");
    await setMarketPrice(datas, dispatch);
    await setTradePair(datas, dispatch);
    // socketContext.socket.off("marketPrice");
  };

  const handleAsset = async () => {
    try {
      let totalAmount = 0;
      let lockedBal = 0;
      let tempArr = [...walletData];
      let currencyArr = [];
      currency?.length >= 0 &&
        currency.map((item, index) => {
          let PriceCnv = priceConversion.find(
            (el) =>
              el.baseSymbol == item.currencySymbol && el.convertSymbol == "USD",
          );

          currencyArr.push({
            image: item.image,
            coin: item.currencySymbol,
            decimals: item.decimals,
            gateWay: item.gateWay,
            USDValue: !isEmpty(PriceCnv?.convertPrice)
              ? parseFloat(PriceCnv.convertPrice)
              : 1,
          });

          let pairIndex =
            tempArr &&
            tempArr.findIndex((el) => {
              return el._id == item._id;
            });
          if (pairIndex >= 0 && !isEmpty(pairIndex)) {
            tempArr[pairIndex] = {
              ...tempArr[pairIndex],
              ...{
                lockedBal: !isEmpty(PriceCnv?.convertPrice)
                  ? parseFloat(tempArr[pairIndex].lockedBal) *
                    parseFloat(PriceCnv.convertPrice)
                  : parseFloat(tempArr[pairIndex].lockedBal),
                USDValue: !isEmpty(PriceCnv?.convertPrice)
                  ? parseFloat(
                      tempArr[pairIndex].stakeBal -
                        tempArr[pairIndex].lockedBal,
                    ) * parseFloat(PriceCnv.convertPrice)
                  : parseFloat(
                      tempArr[pairIndex].stakeBal -
                        tempArr[pairIndex].lockedBal,
                    ),
              },
            };
            totalAmount += tempArr[pairIndex].USDValue;
            lockedBal += tempArr[pairIndex].lockedBal;
          }
        });
      setCurrency(currencyArr);

      let result = {
        totalBal: truncateDecimals(totalAmount, 2),
        lockedBal: truncateDecimals(lockedBal, 2),
      };
      setAvailable(result);
    } catch (err) {
      console.log("err:------ ", err);
    }
  };

  const fetchTradeHistory = async () => {
    const { status, result } = await getAllOpenPosition({});
    if (status == "success") {
      // console.log(result)
      setTradeData(result);
      let totalPnl = 0;
      result?.result &&
        result?.result?.length > 0 &&
        result.result.map((item, key) => {
          let price = item.side == "sell" ? item.askPrice : item.bidPrice;
          let pnl = unrealizedPnL({
            entryPrice: item.entryPrice,
            quantity: item.quantity,
            lastPrice: price,
            buyorsell: item.side,
          });
          totalPnl += pnl;
        });
      setTotalPNL(truncateDecimals(totalPnl, 2));
    }
  };

  const handleCloseAll = async () => {
    try {
      setCloseAllLoder(true);
      const { status, loading, message, result, errors } =
        await closeAllOrder();
      if (status) {
        setCloseAllLoder(false);
        toastAlert("success", t(message), "login");
      } else {
        setCloseAllLoder(false);
        toastAlert("error", t(message), "login");
      }
    } catch (err) {
      setCloseAllLoder(false);
      console.log(err, "errorr");
    }
  };

  useEffect(() => {
    let pathname = location.pathname;

    if (!isEmpty(pairData)) {
      if (pathname == "/protrade/" + pairData.tikerRoot) {
        // console.log("1111111");
        // socket
        let allPairPriceUpdate = [...pairdatas];
        socketContext.socket.on("marketPrice", (result) => {
          if (result.pairId == pairData.pairId) {
            setMarketPrice(result.data, dispatch);
            let tempPairList = pairLists;
            let pairIndex = tempPairList.findIndex(
              (el) => el._id == result.pairId,
            );
            if (pairIndex >= 0) {
              tempPairList[pairIndex] = {
                ...tempPairList[pairIndex],
                ...{ markPrice: 0, change: result.data.change },
              };
              setPairLists(tempPairList);
            }
          }
          if (result) {
            let pairIndex = allPairPriceUpdate.findIndex((el) => {
              return el._id.toString() == result.pairId.toString();
            });
            if (pairIndex >= 0) {
              allPairPriceUpdate[pairIndex] = {
                ...allPairPriceUpdate[pairIndex],
                ...{
                  bidPrice: result?.data?.bidPrice,
                  askPrice: result?.data?.askPrice,
                  markPrice: result?.data?.markPrice,
                  change: result?.data?.change,
                },
              };
              // setPairList(tempPairList ,dispatch)
              setTotalPair(allPairPriceUpdate);
            }
          }
        });
        return () => {
          socketContext.socket.off("marketPrice");
        };
      }
    }
  }, [pairData]);

  useEffect(() => {
    if (pairListData && pairListData.length > 0) {
      let symbol = [];

      for (var i = 0; i < pairListData.length; i++) {
        if (pairListData[i].type == "crypto") {
          symbol.push({
            proName:
              "BINANCE:" +
              pairListData[i].firstCurrencySymbol +
              pairListData[i].secondCurrencySymbol,
          });
        }
      }

      setSymbols(symbol);

      setPairLists(pairListData);
      setTotalPair(pairListData);
    }
  }, [pairListData]);

  useEffect(() => {
    fetchPairList();
    fetchTradeHistory();
    getallPendingData();
  }, []);

  useEffect(() => {
    handleAsset();
    socketContext.socket.on("updateWallet", (result) => {
      // console.log(result, '888888888')
      dispatch(userWalletList(result?.walletData));
    });
  }, [currency, walletData, priceConversion]);

  useEffect(() => {
    if (tradedata && tradedata.length > 0 && !isEmpty(totalpair)) {
      let totalPnl = 0;
      tradedata &&
        tradedata?.length > 0 &&
        tradedata.map((item, key) => {
          let filter =
            totalpair &&
            totalpair.find((el) => el._id.toString() == item.pairId.toString());
          // console.log(filter?.spread, 'filterfilter')
          let price = item.side == "sell" ? filter?.askPrice : filter?.bidPrice;
          let pnl = unrealizedPnL({
            entryPrice: item.entryPrice,
            quantity: item.quantity,
            lastPrice: price,
            buyorsell: item.side,
          });
          let totalSpread =
            parseFloat(item?.userId?.userSpread) +
            parseFloat(filter?.spread) +
            parseFloat(item?.tradeSpread);
          let margin = (price * item.quantity) / 100;
          let pnlper = (totalSpread * margin) / 100;
          totalPnl += pnl + pnlper;
        });
      setTotalPNL(truncateDecimals(totalPnl, 2));
    }
  }, [marketPrice, totalpair, tradedata]);

  let Equity = parseFloat(available.totalBal) + parseFloat(totalPNL);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    margin: 30,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const [Info, setInfo] = useState();

  // console.log(Info, "-InfoInfo");

  let FindImage =
    pairLists.length > 0 &&
    pairLists.find((item) => item?._id === Info?.pairId?._id);

  const tradePanelContent = (
    <div className="w-full h-full bg-white rounded-sm lg:outline lg:outline-1 lg:outline-offset-[-1px] lg:outline-[#eff1f0] lg:p-4">
      <div className="staking_calc trade_buy">
        <div className="staking_method_btngrp !flex-nowrap">
          <button
            className={
              activeTradeMethod === "buy"
                ? "trade_buy trade_btn active"
                : "trade_buy trade_btn"
            }
            onClick={() => handleStakingMethodClick("buy")}
          >
            {t("BUY")}
          </button>
          <button
            className={
              activeTradeMethod === "sell"
                ? "trade_sell trade_btn active"
                : "trade_sell trade_btn"
            }
            onClick={() => handleStakingMethodClick("sell")}
          >
            {t("SELL")}
          </button>
        </div>
        <div className="">
          <div className="form-group">
            <label className="form-label">{t("ASSET")}</label>

            <Dropdown className="image_dropdown_wrapper" drop="down">
              <Dropdown.Toggle id="dropdown-basic" className="image_dropdown">
                <Image src={pairData.image} width={38} height={38} />
                {pairData.firstCurrencySymbol}/{pairData.secondCurrencySymbol}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {pairLists.map((option, i) => {
                  let symbole = `${option.firstCurrencySymbol}/${option.secondCurrencySymbol}`;
                  return (
                    <Dropdown.Item
                      key={i}
                      onClick={() => handlePairChange(option)}
                    >
                      <Image src={option.image} width={38} height={38} />{" "}
                      {symbole}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <Orderplace
            type={activeTradeMethod}
            refetch={fetchTradeHistory}
            pendingrefetch={getallPendingData}
            handleAsset={handleAsset}
            pairData={pairData}
            totalpair={totalpair}
          />
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="p-4 pb-24 lg:pb-4">
        <div className="w-full flex justify-start items-center gap-4">
          <div className="flex-1 relative rounded overflow-hidden border border-[#6B7280]/25">
            <TradingViewWidget symbols={symbols} />
          </div>
          <Link to="/trade" className="primary_btn hidden lg:flex">
            <div className="">{t("BASIC")}</div>
          </Link>
        </div>
        <div className="md:border border-[#6B7280]/25 md:p-4 rounded mt-4">
          <div className="w-full flex justify-end mb-4 lg:hidden">
            <Link to="/trade" className="primary_btn flex">
              <div className="">{t("BASIC")}</div>
            </Link>
          </div>
          <div className="w-full self-stretch p-3 lg:p-2 relative bg-[#F4F3F3] shadow-sm rounded-sm flex flex-wrap lg:flex-nowrap justify-between lg:justify-start items-center gap-y-4 lg:gap-6 overflow-hidden">
            <img
              className="absolute right-0 top-0 h-full object-cover  pointer-events-none hidden lg:block"
              style={{ filter: "blur(0px)", mixBlendMode: "color-burn" }}
              src="/images/inner/bg.png"
              alt="background"
            />
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">
                {t("PNL")}:
              </div>
              <div
                className={`justify-center text-sm font-semibold font-['Roobert'] ${totalPNL >= 0 ? "text-[#395645]" : "text-red-500"}`}
              >
                ${" "}
                <CurrencyFormat
                  displayType={"text"}
                  thousandSeparator={true}
                  value={truncateDecimals(totalPNL, 2)}
                />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">
                {t("CASH_BALANCE")}:
              </div>
              <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                ${" "}
                <CurrencyFormat
                  displayType={"text"}
                  thousandSeparator={true}
                  value={available?.totalBal}
                />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">
                {t("EQUITY")}:
              </div>
              <div
                className={`justify-center text-sm font-semibold font-['Roobert'] ${Equity >= 0 ? "text-[#395645]" : "text-red-500"}`}
              >
                ${" "}
                <CurrencyFormat
                  displayType={"text"}
                  thousandSeparator={true}
                  value={truncateDecimals(Equity, 2)}
                />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">
                {t("USED_MARGIN")}:
              </div>
              <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                ${" "}
                <CurrencyFormat
                  displayType={"text"}
                  thousandSeparator={true}
                  value={available?.lockedBal}
                />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">
                {t("AVAILABLE_MARGIN")}:
              </div>
              <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                ${" "}
                <CurrencyFormat
                  displayType={"text"}
                  thousandSeparator={true}
                  value={available?.totalBal}
                />
              </div>
            </div>
          </div>
          

          {/* Row 1: Order Book, Chart, Technical */}
          <div className="flex flex-col lg:flex-row gap-4 mt-4">
            <div className="hidden lg:block w-full xl:w-[25%]">
              {tradePanelContent}
            </div>
            <div className="w-full xl:w-[50%] flex flex-col">
              <div className="w-full h-[500px] lg:h-full min-h-[500px] bg-white rounded-sm ">
                <div className="tradingview-widget-container h-full">
                  <TradeviewChart />
                </div>
              </div>
            </div>
            <div className="w-full xl:w-[25%] flex flex-col">
              <div className="w-full h-[500px] lg:h-full bg-white rounded-sm outline outline-1 outline-offset-[-1px] outline-[#6B7280]/25 p-4">
                <OrderBook />
              </div>
            </div>
          </div>

          <div className="w-full  mt-4">
            <div className="staking_top_flex">
              <ul
                className="nav nav-pills custom_nav_tabs w-100"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-OpenPosition-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-OpenPosition"
                    type="button"
                    role="tab"
                    aria-controls="pills-OpenPosition"
                    aria-selected="true"
                  >
                    {t("OPEN_POSITIONS")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-trade-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-trade"
                    type="button"
                    role="tab"
                    aria-controls="pills-trade"
                    aria-selected="false"
                  >
                    {t("CLOSED_POSITIONS")}
                  </button>
                </li>
                {pendingdata.length > 0 && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-PendPosition-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-PendPosition"
                      type="button"
                      role="tab"
                      aria-controls="pills-PendPosition"
                      aria-selected="true"
                    >
                      {t("PENDING_POSITIONS")}
                    </button>
                  </li>
                )}
                {tradedata.length > 0 && (
                  <li className="ms-lg-auto">
                    <button
                      className="nav-link active primary_btn close_btn"
                      disabled={CloseAllLoder}
                      onClick={handleCloseAll}
                    >
                      {t("CLOSE_ALL_TRADES")}
                    </button>
                  </li>
                )}
              </ul>
            </div>
            <div className="tab-content mt-4" id="pills-tabContent">
              {pendingdata.length > 0 && (
                <div
                  className="tab-pane fade"
                  id="pills-PendPosition"
                  role="tabpanel"
                  aria-labelledby="pills-PendPosition-tab"
                >
                  <PendingPosition
                    totalpair={totalpair}
                    refetch={getallPendingData}
                    handleAsset={handleAsset}
                  />
                </div>
              )}
              <div
                className="tab-pane fade show active"
                id="pills-OpenPosition"
                role="tabpanel"
                aria-labelledby="pills-OpenPosition-tab"
              >
                <OpenPosition
                  totalpair={totalpair}
                  refetch={fetchTradeHistory}
                  pendingrefetch={getallPendingData}
                  handleAsset={handleAsset}
                />
              </div>
              <div
                className="tab-pane fade"
                id="pills-trade"
                role="tabpanel"
                aria-labelledby="pills-trade-tab"
              >
                <ClosedOrders setInfo={setInfo} totalpair={totalpair} />
              </div>
            </div>
          </div>

          {/* Row 2: Buy/Sell, Finance Heatmap, Top Stories */}
          <div className="flex flex-col lg:flex-row gap-4 mt-4">
            <div className="w-full xl:w-[25%] flex flex-col">
              <TechnicalWidget />
            </div>
            <div className="w-full xl:w-[50%] flex flex-col">
              <div className="w-full min-h-[400px] h-full bg-white rounded-sm ">
                <FinanceHeatmap />
              </div>
            </div>
            <div className="w-full xl:w-[25%] flex flex-col">
              <div className="w-full min-h-[400px] h-full bg-white rounded-sm ">
                <TopStories />
              </div>
            </div>
          </div>

          {/* Row 3: Equity Heatmap, Economic Calendar */}
          <div className="flex flex-col lg:flex-row gap-4 mt-4">
            <div className="w-full xl:w-[60%] flex flex-col">
              <div className="w-full min-h-[400px] lg:h-full bg-white rounded-sm ">
                <EquityHeatMap />
              </div>
            </div>
            <div className="w-full xl:w-[40%] flex flex-col">
              <div className="w-full h-full bg-white rounded-sm ">
                <EconomicCalender />
              </div>
            </div>
          </div>
          
        </div>
      </div>

      {/* Close Trade Info */}
      <div
        className="offcanvas offcanvas-end close_trade_info_offcanvas"
        tabindex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5
            className="offcanvas-title d-flex gap-2 align-items-center"
            id="offcanvasRightLabel"
          >
            <img src={FindImage?.image} alt="img" width={30} height={30} />
            {Info?.pairName}
          </h5>
          <button
            type="button"
            className="border-0 bg-transparent p-0"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 0.9375C13.4528 0.9375 17.0625 4.54721 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.54721 17.0625 0.9375 13.4528 0.9375 9C0.9375 4.54721 4.54721 0.9375 9 0.9375ZM7.22315 6.16846C6.92858 5.9282 6.49432 5.94517 6.21973 6.21973C5.94523 6.49432 5.92822 6.9286 6.16846 7.22315L6.21973 7.28027L7.93943 9L6.22046 10.7198C5.92768 11.0126 5.92758 11.4874 6.22046 11.7802C6.51335 12.0729 6.98818 12.073 7.28101 11.7802L9 10.0606L10.719 11.7802L10.7762 11.8316C11.0706 12.0718 11.5049 12.0547 11.7796 11.7802C12.0541 11.5058 12.0716 11.0714 11.8316 10.7768L11.7796 10.7198L10.0598 9L11.7802 7.28027L11.8316 7.22315C12.0718 6.92859 12.0547 6.49432 11.7802 6.21973C11.5057 5.94517 11.0714 5.9282 10.7768 6.16846L10.7198 6.21973L9 7.93943L7.28027 6.21973L7.22315 6.16846Z"
                fill="#395645"
              />
            </svg>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="close_trade_info">
            <div>
              <label>Order Id</label>
              <label>{IncCntObjId(Info?._id)}</label>
            </div>
            <div>
              <label>PNL</label>
              <label>{truncateDecimals(Info?.pnl, 2)}</label>
            </div>
            <div>
              <label>Open Date</label>
              <label>{dateTimeFormat(Info?.openAt)}</label>
            </div>
            <div>
              <label>Close Date</label>
              <label>{dateTimeFormat(Info?.closedAt)}</label>
            </div>
            <div>
              <label>Open Price</label>
              <label>{truncateDecimals(Info?.entryPrice, 2)}</label>
            </div>
            <div>
              <label>Close Price</label>
              <label>{truncateDecimals(Info?.exitPrice, 2)}</label>
            </div>
            <div>
              <label>Used Margin</label>
              <label>{truncateDecimals(Info?.orderCost, 2)} USD</label>
            </div>
            <div>
              <label>Trade Size</label>
              <label>{truncateDecimals(Info?.quantity, 6)}</label>
            </div>
            <div>
              <label>Lots</label>
              <label>{Info?.leverage}</label>
            </div>
            <div>
              <label>Direction</label>
              <label
                className={
                  Info?.direction === "closed_long" ? "txt_green" : "txt_red"
                }
              >
                {Info?.direction === "closed_long" ? "BUY" : "SELL"}
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sticky Buy/Sell Buttons */}
      <div className="lg:hidden fixed bottom-0 left-0 w-full bg-white border-t border-[#eff1f0] p-3 flex justify-between gap-3 z-[1000] shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
        <button
          className="flex-1 bg-[#00b881] text-white md:py-3 py-2 rounded font-semibold font-['Roobert'] text-lg"
          onClick={() => {
            handleStakingMethodClick("buy");
            setShowMobileTrade(true);
          }}
        >
          {t("BUY")}
        </button>
        <button
          className="flex-1 bg-[#ff4d4f] text-white sm:py-3 py-2 rounded font-semibold font-['Roobert'] text-lg"
          onClick={() => {
            handleStakingMethodClick("sell");
            setShowMobileTrade(true);
          }}
        >
          {t("SELL")}
        </button>
      </div>

      {/* Mobile Trade Offcanvas */}
      <Offcanvas
        show={showMobileTrade}
        onHide={() => setShowMobileTrade(false)}
        placement="bottom"
        className="h-auto lg:hidden rounded-t-xl"
      >
        <Offcanvas.Header className="border-b border-[#eff1f0] py-3 justify-end">
          <button
            type="button"
            className="border-0 bg-transparent p-0"
            onClick={() => setShowMobileTrade(false)}
            aria-label="Close"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 0.9375C13.4528 0.9375 17.0625 4.54721 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.54721 17.0625 0.9375 13.4528 0.9375 9C0.9375 4.54721 4.54721 0.9375 9 0.9375ZM7.22315 6.16846C6.92858 5.9282 6.49432 5.94517 6.21973 6.21973C5.94523 6.49432 5.92822 6.9286 6.16846 7.22315L6.21973 7.28027L7.93943 9L6.22046 10.7198C5.92768 11.0126 5.92758 11.4874 6.22046 11.7802C6.51335 12.0729 6.98818 12.073 7.28101 11.7802L9 10.0606L10.719 11.7802L10.7762 11.8316C11.0706 12.0718 11.5049 12.0547 11.7796 11.7802C12.0541 11.5058 12.0716 11.0714 11.8316 10.7768L11.7796 10.7198L10.0598 9L11.7802 7.28027L11.8316 7.22315C12.0718 6.92859 12.0547 6.49432 11.7802 6.21973C11.5057 5.94517 11.0714 5.9282 10.7768 6.16846L10.7198 6.21973L9 7.93943L7.28027 6.21973L7.22315 6.16846Z"
                fill="#395645"
              />
            </svg>
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-4">{tradePanelContent}</Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ProTrade;
